import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50ed34c3")

_pushScopeId("data-v-50ed34c3")
const _hoisted_1 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_3 = { class: "flex flex-row mb-4" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("単元を追加")
const _hoisted_6 = { class: "flex flex-col mb-8" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-full flex flex-row py-4 px-6 bg-gray-200" }, [
  /*#__PURE__*/_createVNode("h2", { class: "font-bold text-xl" }, "単元名")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex-1 text-left break-all pr-3 pl-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("閲覧")
const _hoisted_11 = {
  key: 0,
  class: "w-12 px-3 py-3 flex text-gray-400"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-10 text-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MSPanelHeader, { "select-page": "reflection" }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (
            (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool) &&
              _ctx.canEditStudent
          )
            ? (_openBlock(), _createBlock(_component_m_button, {
                key: 0,
                class: "mr-2",
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.openReflectionAddModal
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_4, [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "2"
                    }),
                    _hoisted_5
                  ])
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("section", _hoisted_6, [
          _hoisted_7,
          (_ctx.units.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.units, (unit, i) => {
                  return (_openBlock(), _createBlock("div", {
                    key: i,
                    class: "w-full flex flex-row justify-between items-center px-4 py-2 border-b border-gray-400"
                  }, [
                    _createVNode("div", _hoisted_9, _toDisplayString(unit.data.name), 1),
                    _createVNode(_component_m_button, {
                      color: "gray-800",
                      outline: "",
                      "hover-color": "gray-900",
                      onClick: ($event: any) => (_ctx.select({ type: 'display', value: unit }))
                    }, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (_ctx.canEditStudent)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("div", {
                            class: "p-1 rounded-md cursor-pointer hover:bg-gray-100",
                            onClick: _withModifiers(($event: any) => (_ctx.select({ type: 'edit', value: unit })), ["prevent"])
                          }, [
                            _createVNode(_component_m_icon, { type: "pencil" })
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.loading ? "情報取得中..." : "単元がありません。"), 1))
        ])
      ])
    ])
  ], 64))
})